module.exports = __webpack_public_path__ + "static/media/karacuhahukuk&danismanlik.3a129284.jpeg";